import slice from './reducer'

export const { updateFilters: portalUserFilters } = slice.actions

export default slice.reducer
